module.exports = __webpack_public_path__ + "static/media/BX.4b75e27f.png";